import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../../services/etiquetado.service';
import { Subject } from 'rxjs';
import { pairwise, startWith, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-etq-denominacion-new-edit',
    templateUrl: './new-edit.component.html'
})
export class EtqDenominacionNewEditComponent implements OnInit, OnDestroy {

    private readonly destroy$ = new Subject<void>();
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public deleteModal = false;
    public marcasModal = false;

    public paisId;
    public denominacionId;


    private _editable: boolean;
    private _toDelete: any;
    public denominaciones;

    public firstTime = true;
    private _filters;

    public grupoEtiquetaIdCaja;
    public grupoEtiquetaIdPallet;

    public disabledPais: Subject<boolean> = new Subject();
    public disabledDenominacion: Subject<boolean> = new Subject();
    public disabledCaja: Subject<boolean> = new Subject();
    public disabledPallet: Subject<boolean> = new Subject();

    public randomId = Math.random();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                if (this.denominacion) {
                    this.disabledPais.next(true);
                } else {
                    this.disabledPais.next(false);
                }
                if (this._sessionContext.sessionUser.role !== 'Administrador') {
                    this.disabledCaja.next(true);
                    this.disabledPallet.next(true);
                    this.newEditForm.get('grupoEtiquetasCaja').disable();
                    this.newEditForm.get('grupoEtiquetasPallet').disable();
                } else {
                    this.disabledCaja.next(false);
                    this.disabledPallet.next(false);
                }
                this.disabledDenominacion.next(true);
            } else {
                this.newEditForm.disable();
                this.disabledPais.next(true);
                this.disabledDenominacion.next(true);
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);
                this.newEditForm.get('grupoEtiquetasCaja').disable();
                this.newEditForm.get('grupoEtiquetasPallet').disable();
                this.newEditForm.patchValue(this.denominacion);
                this.newEditForm.patchValue({
                    pais: this.paises.find(x => x.id === this.denominacion.paisId),
                });

                if (this._sessionContext.sessionUser.role === 'Administrador') {
                    this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === 0));
                    this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet[0]);

                    for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                        if (grupoEtiquetaCaja.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasCaja')
                                .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                            this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                        }
                    }
                    for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                        if (grupoEtiquetaPallet.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasPallet')
                                .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                            this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                        }
                    }
                }
            }
        }
    }
    @Input() denominacion?;
    @Input() etiquetadorId: number;
    @Input() allGrupoEtiquetasCaja;
    @Input() allGrupoEtiquetasPallet;
    @Input() grupoEtiquetasCaja;
    @Input() grupoEtiquetasPallet;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private _etiquetadoService: EtiquetadoService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService,
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            pais: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasCaja: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasPallet: [{ value: '', disabled: !this.editable }, Validators.required],
            impresionAutorizada: [{ value: '', disabled: !this.editable }],
            reimpresionAutorizada: [{ value: '', disabled: !this.editable }],
            denominacion: [{ value: '', disabled: true }, Validators.required]
        });

        this.newEditForm.get('pais').valueChanges
        .pipe(startWith(undefined), pairwise(), takeUntil(this.destroy$))
        .subscribe(([paisOld, pais]: [any, any]) => {
            if (pais) {
                if ((paisOld !== pais)) {
                    this._filters = {
                        paisId: pais.id
                    };
                    this._spinnerService.showSpinner();
                    this._etiquetadoService.getDenominacionesPais(this._filters).toPromise().finally(() => {
                        this._spinnerService.hideSpinner();
                    }).then((resp) => {
                        if (resp.lista.length > 0) {
                            this.denominaciones = resp.lista;
                            if (this.denominaciones.length === 1) {
                                this.newEditForm.get('denominacion').patchValue(this.denominaciones[0]);
                                this.newEditForm.get('denominacion').disable();
                                this.disabledDenominacion.next(true);
                            } else {
                                this.newEditForm.get('denominacion').enable();
                                this.disabledDenominacion.next(false);
                            }
                            if (this.denominacion) {
                                this.disabledDenominacion.next(true);
                                this.newEditForm.get('denominacion').patchValue(
                                    this.denominaciones.find(x => x.id === this.denominacion.denominacionId));
                            }
                        }
                    });
                }
            } else {
                this.denominaciones = [];
                this.disabledDenominacion.next(true);
            }
        });

        if (this.denominacion) {
            this.newEditForm.patchValue(this.denominacion);
            this.newEditForm.patchValue({
                pais: this.paises.find(x => x.id === this.denominacion.paisId),
            });
            this.newEditForm.disable();
            this.disabledPais.next(true);
            this.disabledDenominacion.next(true);
            this.disabledCaja.next(true);
            this.disabledPallet.next(true);
            this.newEditForm.get('grupoEtiquetasCaja').disable();
            this.newEditForm.get('grupoEtiquetasPallet').disable();
        } else {
            this.disabledPais.next(false);
        }

        if (this.role === "Administrador") {
            if (this.grupoEtiquetasCaja) {
                this.newEditForm.get('grupoEtiquetasCaja')
                    .patchValue(this.allGrupoEtiquetasCaja[0]);
                for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                    if (grupoEtiquetaCaja.grupoEtiquetaId) {
                        this.newEditForm.get('grupoEtiquetasCaja')
                            .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                        this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                    }
                }
            } else {
                this.newEditForm.get('grupoEtiquetasCaja')
                    .patchValue(this.allGrupoEtiquetasCaja[0]);
            }

            if (this.grupoEtiquetasPallet) {
                this.newEditForm.get('grupoEtiquetasPallet')
                    .patchValue(this.allGrupoEtiquetasPallet[0]);
                for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                    if (grupoEtiquetaPallet.grupoEtiquetaId) {
                        this.newEditForm.get('grupoEtiquetasPallet')
                            .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                        this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                    }
                }
            } else {
                this.newEditForm.get('grupoEtiquetasPallet')
                    .patchValue(this.allGrupoEtiquetasPallet[0]);
            }
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.newEditForm.get('pais').enabled) {
              this.newEditForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.newEditForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public save(denominacion) {
        this.checkForm();
        if (this.newEditForm.valid) {
            if (!denominacion) {
                const newDenominacion = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: this.newEditForm.get('pais').value.id,
                    denominacionId: this.newEditForm.get('denominacion').value.id,
                    impresionAutorizada: this.newEditForm.get('impresionAutorizada').value ?
                        this.newEditForm.get('impresionAutorizada').value : false,
                    reimpresionAutorizada: this.newEditForm.get('reimpresionAutorizada').value ?
                        this.newEditForm.get('reimpresionAutorizada').value : false,
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.createDenominacionEtiquetador(newDenominacion).toPromise().finally(() => {
                }).then((resp) => {
                    if (resp) {
                        this._editable = false;
                        if (this.role === "Administrador") {
                            const promises: Promise<any>[] = [];
                            promises.push(
                                this.updateGrupoEtiquetasCaja(resp)
                            );

                            promises.push(
                                this.updateGrupoEtiquetasPallet(resp)
                            );
                            Promise.all(promises).then(
                                () => {
                                    this._spinnerService.hideSpinner();
                                    this.refresh.emit(true);
                                    this.newEditForm.disable();
                                    this.disabledPais.next(true);
                                    this.disabledDenominacion.next(true);
                                    this.disabledCaja.next(true);
                                    this.disabledPallet.next(true);
                                    this.pushMessage.emit('global.success.itemCreated');
                                    return true;
                                }, (error) => {
                                    this.pushMessage.emit('global.error.noResponse');
                                    console.log('Promise rejected with ' + JSON.stringify(error));
                                }
                            ).catch(e => console.log(e));
                        } else {
                            this._spinnerService.hideSpinner();
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledPais.next(true);
                            this.disabledDenominacion.next(true);
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.pushMessage.emit('global.success.itemCreated');
                        }
                    }
                },
                (error) => {
                    this._spinnerService.hideSpinner();
                    this.showError = true;
                    let mensaje;
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                          case 6060:
                            mensaje = this._translate.instant('ApiErrors.EPDYaExiste');
                            break;
                          default:
                            mensaje = this._translate.instant('ApiErrors.serverError');
                            break;
                        }
                    } else {
                    mensaje = this._translate.instant('ApiErrors.serverError');
                    }
                    this.mensajes.push({ class: 'error', message: mensaje });
                });
            } else {
                const updateDenominacion = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: denominacion.paisId,
                    denominacionId: denominacion.denominacionId,
                    impresionAutorizada: this.newEditForm.get('impresionAutorizada').value ?
                        this.newEditForm.get('impresionAutorizada').value : false,
                    reimpresionAutorizada: this.newEditForm.get('reimpresionAutorizada').value ?
                        this.newEditForm.get('reimpresionAutorizada').value : false
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.updateDenominacionEtiquetador(updateDenominacion).toPromise().finally(() => {
                }).then(
                    (resp) => {
                        if (this.role === "Administrador") {
                            const promises: Promise<any>[] = [];
                            promises.push(
                                this.updateGrupoEtiquetasCaja()
                            );
                            promises.push(
                                this.updateGrupoEtiquetasPallet()
                            );
                            Promise.all(promises).then(
                                () => {
                                    this._spinnerService.hideSpinner();
                                    this.refresh.emit(true);
                                    this.newEditForm.disable();
                                    this.disabledPais.next(true);
                                    this.disabledDenominacion.next(true);
                                    this.disabledCaja.next(true);
                                    this.disabledPallet.next(true);
                                    this.pushMessage.emit('global.success.itemUpdated');
                                    return true;
                                }, (error) => {
                                    this.pushMessage.emit('global.error.noResponse');
                                    console.log('Promise rejected with ' + JSON.stringify(error));
                                }
                            ).catch(e => console.log(e));
                        } else {
                            this._spinnerService.hideSpinner();
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledPais.next(true);
                            this.disabledDenominacion.next(true);
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.pushMessage.emit('global.success.itemUpdated');
                        }
                    });
            }
        } else {
            this.showError = true;
        }
    }

    public updateGrupoEtiquetasCaja(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasCaja').value.id !== 0) {
                const updateGrupoEtiquetaCaja = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: resp ? resp.paisId : this.denominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.denominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasCaja').value.id
                };
                this._etiquetadoService.updateGruposEtiquetaEtiquetadorPaisDenominacion(updateGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasCaja').value.id === 0 && this.grupoEtiquetaIdCaja) {
                const deleteGrupoEtiquetaCaja = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: resp ? resp.paisId : this.denominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.denominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdCaja
                };
                this._etiquetadoService.deleteGruposEtiquetaEtiquetadorPaisDenominacion(deleteGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public updateGrupoEtiquetasPallet(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasPallet').value.id !== 0) {
                const updateGrupoEtiquetaPallet = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: resp ? resp.paisId : this.denominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.denominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasPallet').value.id
                };
                this._etiquetadoService.updateGruposEtiquetaEtiquetadorPaisDenominacion(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasPallet').value.id === 0 && this.grupoEtiquetaIdPallet) {
                const deleteGrupoEtiquetaPallet = {
                    etiquetadorId: this.etiquetadorId,
                    paisId: resp ? resp.paisId : this.denominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.denominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdPallet
                };
                this._etiquetadoService.deleteGruposEtiquetaEtiquetadorPaisDenominacion(deleteGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }


    public cancel() {
        this.newEditForm.reset();
        this.editableChanged.emit(false);
    }

    public edit(denominacion) {
        this.newEditForm.get('impresionAutorizada').enable();
        this.newEditForm.get('reimpresionAutorizada').enable();
        if (this._sessionContext.sessionUser.role === 'Auditor') {
            this.disabledPais.next(false);
            this.disabledCaja.next(false);
            this.disabledPallet.next(false);
        } else {
            this.disabledPais.next(true);
            this.disabledCaja.next(true);
            this.disabledPallet.next(true);
        } 
        this.editableChanged.emit(denominacion);
    }

    public askDelete() {
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteDenominacionEtiquetador(this.etiquetadorId, this.denominacion.paisId, this.denominacion.denominacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.closeModal();
            this.refresh.emit(true);
            this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    public openMarcas(denominacion) {
        this.paisId = denominacion.paisId;
        this.denominacionId = denominacion.denominacionId;
        this.marcasModal = true;
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public toRefresh(value) {
        this.marcasModal = false;
    }
}
